(() => {
	const JobQuestionnaireController = (
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$sce,
		$window,
		$filter,
		$q,
		messageService,
		fileUploadService,
		jobDataService,
		emailService,
		userService,
		newJobsDataService,
		leadDataService,
		workflowService,
		workflowDataService,
		settingsService,
		mailsDataService
	) => {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		if ($scope.isLeadView) {
			$scope.isArchived = true;
		}
		let isFirstShow = true;
		$scope.$on('$viewContentLoaded', () => {
			$scope.isSentSpinnningWheelActive = false;
			$scope.isDeleteSpinnningWheelActive = false;
			$scope.questionnaireId = $routeParams.questionnaireId;
			$scope.jobId = $routeParams.jobId;
			$scope.leadId = $routeParams.leadId;

			if ($scope.isLeadView) {
				getLead($routeParams.leadId);
			} else if ($scope.isJobView) {
				getJobInfo($routeParams.jobId);
			}
			$scope.gdprEnabled = userService.userData.isGdprEnabled;
		});

		$(document).on('shown.bs.modal', '#sendQuestionnaireModal', () => {
			if (isFirstShow) {
				isFirstShow = false;
				if ($scope.task !== undefined && $scope.isDisable) {
					$scope.attachmentsData.attachments = JSON.parse(
						JSON.stringify($scope.task.taskEmail.storedAttachments)
					);
				} else {
					$scope.attachmentsData = {
						attachments: [],
						filesSize: 0
					};
				}
			}
		});
		function getLead(id, showTaskId = '') {
			leadDataService.getLeadInfo(id, showTaskId).subscribe(
				result => {
					$scope.jobId = result.job.id;
					$scope.isArchived = result.archived;
					if ($scope.jobId !== undefined) {
						getQuestionnairesInformation($scope.jobId);
					}
				},
				error => {
					const { errorCode, data } = error;
					if (errorCode === 701) {
						redirectToJobLead(data);
					}
				}
			);
		}

		function getJobInfo(id, showNewTaskId = '') {
			newJobsDataService.getJobInfo(id, showNewTaskId).subscribe(
				result => {
					$scope.jobId = result.id;
					if ($scope.jobId !== undefined) {
						getQuestionnairesInformation($scope.jobId);
					}
				},
				error => {
					const { errorCode, data } = error;
					if (errorCode === 702) {
						redirectToJobLead(data);
					}
				}
			);
		}

		function redirectToJobLead(data) {
			$location.path(
				`/${data.redirectTo}s/view/${data.redirectId}/questionnaires/${
					$routeParams.questionnaireId
				}`
			);
		}

		clearAttachments();

		$scope.sendMessage = {};

		let clientsEmailTimer;
		$scope.clientEmails = [];

		$scope.$parent.$watch('attachmentsDataQueston', (newValue, oldValue) => {
			if (newValue && newValue !== oldValue) {
				$scope.attachmentsData = newValue;
			}
		});

		function emailSearchRequest(search) {
			jobDataService
				.searchClient(search)
				.then(result => findClientSuccessCallback(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		$scope.setEmail = function(site) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			$scope.sendMessage.emailCc = stringEmail;
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		$scope.$watchCollection('sendMessage', (newValue, oldValue) => {
			$scope.$evalAsync();
			if (newValue) {
				if (!newValue.emailCc) {
					$scope.sendMessage.emailCc =
						angular.element('#sendQuestonnaireMessageData_emailCc').val() || '';
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
			$scope.$evalAsync();
		});

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
			}

			if (state === false) {
				clearAttachments();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		function getQuestionnairesInformation(id) {
			$http
				.get(
					`/protected/rest/jobs/${id}/questionnaire/${
						$routeParams.questionnaireId
					}/get/`
				)
				.then(result => successGetQuestionnairesInformation(result.data))
				.catch(result => errorGetQuestionnairesInformation(result.data));
		}

		function successGetQuestionnairesInformation(data) {
			$scope.$evalAsync();
			$scope.data = data;
			$scope.companyImageSrc = data.company.image;
			settingsService.timeFormatSettings.subscribe(res => {
				if (res.questionnaireTemplatesVersion === 'V2') {
					$scope.isNewQuestionnaireAvailable = true;
				} else {
					$scope.isNewQuestionnaireAvailable = false;
					if (data.questionnaires && data.questionnaires.length > 0) {
						$scope.questionnaire = data.questionnaires[0];
						$scope.questionnaire.questions = $filter('orderBy')(
							$scope.questionnaire.questions,
							'number',
							false
						);
						$scope.contactEmail = data.contactEmail;

						if (data.jobAttachments && data.jobAttachments.length) {
							fileUploadService.setAttachmentsFromServer(data.jobAttachments);
						}

						$scope.$evalAsync();
					}
				}
			});
		}

		function errorGetQuestionnairesInformation(data) {
			if (data.errorMessage) {
				toastr.error(data.errorMessage);
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}
		$scope.deleteModalQuestionnaries = function() {
			if ($scope.isArchived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$('#deleteModal').modal();
			}
		};

		$scope.deleteQuestionnaireV2 = function() {
			messageService.showToaster('s_1', 'questions');
			if ($scope.isJobView) {
				$location.path(`/jobs/view/${$routeParams.jobId}`);
			} else {
				$location.path(`/leads/view/${$scope.data.leadId}`);
			}
		};

		$scope.deleteQuestionnaire = function() {
			$scope.isDeleteSpinnningWheelActive = true;

			const jobId = $scope.jobId ? $scope.jobId : $routeParams.jobId;

			$http({
				method: 'POST',
				url: `/protected/rest/jobs/questionnaires/delete/${jobId}/${
					$routeParams.questionnaireId
				}/`
			}).then(
				result => {
					successDeleteCallback(result.data);
				},
				() => {
					$scope.isDeleteSpinnningWheelActive = false;
				}
			);
		};

		function successDeleteCallback(data) {
			const { errorCode, errorMessage, errorTitle } = data;
			if (errorMessage) {
				if (
					errorMessage.includes(
						'This questionnaire is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
					) &&
					errorCode === 102
				) {
					$('#deleteModal').modal('hide');
					messageService.showToaster('e_0', 'questions');
				} else {
					messageService.showErrorFromBackend('Error', errorMessage);
				}
			} else {
				messageService.showToaster('s_0', 'questions');
				if ($scope.isJobView) {
					$location.path(`/jobs/view/${$routeParams.jobId}`);
				} else {
					$location.path(`/leads/view/${$scope.data.leadId}`);
				}
			}
			$scope.isDeleteSpinnningWheelActive = false;
		}

		$scope.initSendQuestionnaire = function() {
			const url = '/protected/rest/job/questionnaire/sources';

			$http({
				method: 'GET',
				url
			}).then(result => {
				$scope.$evalAsync();
				$scope.questionnaireSendSource = result.data;
				$scope.questionnaireEmailTemplates = result.data.emailTemplates;

				const template =
					$scope.questionnaireEmailTemplates.find(
						item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
					) || {};
				$scope.choosenQuestionnaireEmail = template;
				$scope.setQuestionnaireEmailTemplate(template.id);

				$scope.$evalAsync();

				const rootEmail = $rootScope.primaryContact
					? $rootScope.primaryContact.email || ''
					: '';

				$scope.sendMessage.emailCc = '';
				$scope.emailTo = $scope.contactEmail || rootEmail;

				$('#sendQuestionnaireModal').modal('show');
				$scope.$evalAsync();
			});
		};

		const questionnaireSetEmailCallback = function(data) {
			$scope.questionnaireEmail = angular.copy(data);
			if (data.storedAttachments && data.storedAttachments.length) {
				$scope.attachmentsData = {
					attachments: fileUploadService.convertAttachmentsToShow(
						data.storedAttachments
					)
				};
			} else {
				clearAttachments();
			}
		};

		// Email methods
		$scope.retrySendMail = function() {
			if ($scope.jobId !== undefined) {
				getQuestionnairesInformation($scope.jobId);
			}
			emailService.callLastEmailFn();
		};

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		$scope.setQuestionnaireEmailTemplate = function(id) {
			$scope.getEmailTemplates(id, questionnaireSetEmailCallback);
		};
		$scope.getEmailTemplates = function(id, callback) {
			if (id != null) {
				const emailTemplateUrl = `/protected/rest/settings/email_template/get/${id}?forSend=${true}`;

				$http({
					method: 'GET',
					url: emailTemplateUrl
				}).then(result => {
					$scope.$evalAsync();
					callback(result.data);

					$scope.$evalAsync();
				});
			}
		};
		function saveChangeTask(task) {
			$scope.isSentSpinnningWheelActive = true;
			task.jobId = $scope.jobId;
			if (
				$scope.choosenQuestionnaireEmail !== undefined &&
				$scope.choosenQuestionnaireEmail !== null
			) {
				task.taskEmail.emailTemplateId = $scope.choosenQuestionnaireEmail.id;
			}
			task.taskEmail.subject = $scope.questionnaireEmail.subject;
			task.taskEmail.text = $scope.questionnaireEmail.text;
			if (task.overdueDays !== null) {
				task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
			}
			task.taskEmail.storedAttachments = null;
			task.taskEmail.base64Attachments = null;
			$scope.uploadedAttachments = null;
			if (
				$scope.attachmentsData.attachments &&
				$scope.attachmentsData.attachments.length !== 0
			) {
				task.taskEmail.storedAttachments = $scope.attachmentsData.attachments.filter(
					attachment => attachment.id
				);
				$scope.uploadedAttachments = $scope.attachmentsData.attachments.filter(
					attachment => !attachment.id
				);
			}

			if ($scope.uploadedAttachments && $scope.uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave($scope.uploadedAttachments)
					.then(convertedFilesArr => {
						task.taskEmail.base64Attachments = convertedFilesArr;
						workflowDataService
							.saveTask(task)
							.subscribe(
								data => changeTaskState(data.tasks[data.taskToAnimate]),
								error => errorSaveTask(error.data)
							);
					})
					.catch(error => console.log(error));
			} else {
				workflowDataService
					.saveTask(task)
					.subscribe(
						data => changeTaskState(data.tasks[data.taskToAnimate]),
						error => errorSaveTask(error.data)
					);
			}
		}
		function errorSaveTask(data) {
			$scope.isSentSpinnningWheelActive = false;
			workflowService.errorSaveTask(data);
		}
		const saveTaskWithAttachments = task => {
			prepareEmailAttachments(task.taskEmail).then(
				result => {
					task.taskEmail = result;
					saveChangeTask(task);
				},
				error => {
					scope.button_disabled = false;
				}
			);
		};
		const prepareEmailAttachments = taskEmail => {
			const deferred = $q.defer();
			taskEmail.attachmentsData = $scope.attachmentsData;
			const isAttachments =
				taskEmail.attachmentsData &&
				taskEmail.attachmentsData.attachments.length;

			if (!isAttachments) {
				deferred.resolve(taskEmail);
				return deferred.promise;
			}

			const { attachments, filesSize } = taskEmail.attachmentsData;
			const maxSize = 10; // 10Mb

			if (filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				deferred.reject('Attachments size exceeds the limit');
				return deferred.promise;
			}

			let uploadedAttachments, storedAttachments;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(attachment => !attachment.id);
				$scope.storedAttachmentsForMail = attachments.filter(
					attachment => attachment.id
				);
			}

			taskEmail.storedAttachments =
				storedAttachments && storedAttachments.length
					? storedAttachments
					: null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave(uploadedAttachments)
					.then(convertedFilesArr => {
						$scope.base64AttachmentsForMail = convertedFilesArr;
						deferred.resolve(taskEmail);
					})
					.catch(error => console.log(error));
			} else {
				deferred.resolve(taskEmail);
			}

			delete taskEmail.attachmentsData;
			return deferred.promise;
		};
		$scope.sendQuestionnaireEmail = function(task) {
			if (task !== undefined) {
				saveChangeTask(task);
			} else {
				const maxSize = 10; // 10Mb
				if (
					$scope.attachmentsData &&
					$scope.attachmentsData.filesSize > maxSize
				) {
					messageService.showToaster('w_0', 'attachments');
					return false;
				}

				$scope.isSentSpinnningWheelActive = true;

				const url = '/protected/rest/job/questionnaire/send';
				const obj2save = angular.copy($scope.sendMessage);
				const emailCC2save = $scope.showCcField ? obj2save.emailCc : '';

				$scope.questionnaireEmail.text = $rootScope.addMaiStyling(
					$scope.questionnaireEmail.text
				);

				const questionnaireForSend = {
					emailTo: $scope.emailTo,
					emailCc: emailCC2save,
					emailText: $scope.questionnaireEmail.text,
					emailSubject: $scope.questionnaireEmail.subject,
					questionnaireTemplateId: $routeParams.questionnaireId,
					jobId: $scope.jobId,
					templateId: $scope.questionnaireEmail.id
				};

				const formData = new FormData();
				angular.forEach(questionnaireForSend, (value, key) => {
					console.debug(`key: ${key}  | value: ${value}`);
					formData.append(key, value);
				});
				if ($scope.attachmentsData.attachments !== undefined) {
					const filesFromJob = $scope.attachmentsData.attachments.filter(
						file => file.id
					);
					const filesFromComputer = $scope.attachmentsData.attachments.filter(
						file => !file.id
					);
					angular.forEach(filesFromComputer, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(filesFromJob, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});
				}
				$scope.disableBtnOnSend = true;
				$http({
					method: 'POST',
					url,
					data: formData,
					transformRequest: angular.identity,
					headers: {
						'Content-Type': undefined
					}
				}).then(
					result => {
						const { errorMessage, errorTitle } = result.data;
						if (errorMessage) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
							$scope.disableBtnOnSend = false;
							$scope.isSentSpinnningWheelActive = false;
							return;
						}
						mailsDataService.emitMailUpdateEvent(true);

						$scope.isSentSpinnningWheelActive = false;
						$scope.$evalAsync();
						isFirstShow = true;
						messageService.showToaster('s_9', 'jobView');

						$scope.disableBtnOnSend = false;
						$('#sendQuestionnaireModal').modal('hide');

						$scope.showCcField = false;
						$('#sendContractModal').modal('hide');

						$scope.$evalAsync();

						for (const prop in $scope.sendMessage) {
							$scope.sendMessage[prop] = '';
						}

						if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
							if ($scope.attachmentsData.attachments.length) {
								$scope.attachmentsData.attachments.length = 0;
							}
						}

						if ($scope.isLeadView) {
							$rootScope.updateLeadView();
						}
						if ($scope.isJobView) {
							$rootScope.updateJobView();
						}
					},
					({ status, data }) => {
						isFirstShow = false;
						$scope.isSentSpinnningWheelActive = false;
						$scope.disableBtnOnSend = false;
						const path = $location.path();
						const errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status == 423) {
								const limit = $rootScope.isUserTrial ? 50 : 150;
								messageService.showToaster('e_4', 'generalValidation', limit);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster(
									'e_1',
									'generalValidation',
									$scope.emailTo
								);
							} else if (
								errorMessage.includes(
									'Email text should contain a questionnaire link'
								)
							) {
								messageService.showToaster('e_0', 'questionnaires');
							} else if (errorMessage.includes('Lead is archived')) {
								messageService.showToaster('e_5', 'lead');
							} else if (path.includes('jobs')) {
								messageService.showToaster('e_0', 'questionnaires');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						} else {
							messageService.showToaster('e_0', 'general');
						}
					}
				);
			}
		};
		function changeTaskState(task) {
			task.completed = true;
			newJobsDataService
				.changeTaskState($scope.jobId, task)
				.finally(() => {
					$rootScope.dnd.canMove = true;
				})
				.subscribe(
					data => {
						$scope.isSentSpinnningWheelActive = false;
						toastr.clear();
						messageService.showToaster('i_0', 'jobView');
						task = Object.assign(task, data);
						handleTask(task, $scope.sortedTasksArrQuestionnarie);
						isFirstShow = true;
						delete $scope.task;
						$('#sendQuestionnaireModal').modal('hide');
						messageService.showToaster('s_9', 'jobView');
						if ($scope.isLeadView) {
							$rootScope.updateLeadView();
						}
						if ($scope.isJobView) {
							$rootScope.updateJobView();
						}
					},
					result => {
						toastr.clear();
						messageService.showDefaultErrorMessage(result);
					}
				);
		}
		const handleTask = (task, taskTypes) => {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				const {
					startDate,
					finishDate,
					startTime,
					finishTime,
					location
				} = $scope.job;
				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				const {
					startDate,
					endDate,
					startTime,
					endTime,
					location,
					clientId
				} = task.calendarEvent;
				task.location = location;
				task.startDate = startDate;
				task.endDate = endDate;
				task.startTime = startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (
					task.startDate &&
					(task.startTime === null || task.finishTime === null)
				) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault =
				task.defaultTask && task.dueDate ? task.dueDate : null;
		};
		$scope.modalClose = function() {
			isFirstShow = true;
			if ($scope.isLeadView) {
				$rootScope.updateLeadView();
			} else if ($scope.isJobView) {
				$rootScope.updateJobView();
			}
		};
		$scope.disableDragDrop = function() {
			return true;
		};

		$(document).on('show.bs.modal', '#sendQuestionnaireModal', () => {
			$scope.$broadcast('addedFileEvent');
		});
	};

	angular
		.module('main')
		.controller('JobQuestionnaireController', JobQuestionnaireController);
	JobQuestionnaireController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$sce',
		'$window',
		'$filter',
		'$q',
		'messageService',
		'fileUploadService',
		'jobDataService',
		'emailService',
		'userService',
		'newJobsDataService',
		'leadDataService',
		'workflowService',
		'workflowDataService',
		'settingsService',
		'mailsDataService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/job/jobQuestionnaireController.js